export const SITE_NAME = 'Business Mall'
export const SITE_DESCRIPTION = 'Журнал о бизнесе, людях и трендах'

export const CONTACT_PHONE_DISPLAY = '+7 (961) 078-02-00'
export const CONTACT_PHONE_TEL = '+79610780200'

export const SOCIAL_LINKS = {
  telegram:
    ((import.meta as any).env?.VITE_TELEGRAM_URL as string | undefined) || 'https://t.me/businessmall134',
} as const

export const NAV_ITEMS = [
  { label: 'Главная', path: '/' },
  { label: 'Выпуски', path: '/issues' },
  { label: 'Наши партнеры', path: '/partners' },
  { label: 'О нас', path: '/about' },
  { label: 'Контакты', path: '/contact' },
] as const

export const MAGAZINES = [
  {
    id: 'business-mall-531',
    title: 'Business Mall #531',
    description: 'Январь-Февраль 2026',
    coverUrl: '/covers/issue-531.jpg',
    pdfUrl: '/api/magazines/business-mall-531.pdf',
    calameoBkCode: '005270067c945fba9409d',
    date: '2026-01-15',
  },
  {
    id: 'business-mall-530',
    title: 'Business Mall #530',
    description: 'Декабрь 2025',
    coverUrl: '/covers/issue-530.jpg',
    pdfUrl: '/api/magazines/business-mall-530.pdf',
    calameoBkCode: null,
    date: '2025-12-01',
  },
  {
    id: 'business-mall-529',
    title: 'Business Mall #529',
    description: 'Ноябрь 2025',
    coverUrl: '/covers/issue-529.jpg',
    pdfUrl: '/api/magazines/business-mall-529.pdf',
    calameoBkCode: null,
    date: '2025-11-01',
  },
  {
    id: 'business-mall-528',
    title: 'Business Mall #528',
    description: 'Октябрь 2025',
    coverUrl: '/covers/issue-528.jpg',
    pdfUrl: '/api/magazines/business-mall-528.pdf',
    calameoBkCode: null,
    date: '2025-10-01',
  },
] as const

export const FEATURES = [
  {
    title: 'Актуальные темы',
    description: 'Попадаете в повестку и получаете охват среди предпринимателей и управленцев.',
    icon: 'TrendingUp',
  },
  {
    title: 'Экспертные мнения',
    description: 'Публикации в медиа усиливают доверие к бренду и формируют образ эксперта в нише.',
    icon: 'Users',
  },
  {
    title: 'Практические советы',
    description:
      'Полезный формат даёт выше вовлечение и мягко подводит к заявкам, чем «прямая реклама».',
    icon: 'Lightbulb',
  },
] as const
